import HomeView from './HomeView';

export default HomeView;
